import {
  Component,
  ElementRef,
  Inject,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { Button } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-chart-widget',
  imports: [ChartModule],
  templateUrl: './chart-widget.component.html',
  styleUrl: './chart-widget.component.css',
  standalone: true,
})
export class ChartWidgetComponent {
  widgetHeader: WritableSignal<string> = signal('');
  
  constructor(@Inject('label') public label: any) {
    this.widgetHeader.set(this.label);
  }

  // Beispiel-Daten
  basicData = {
    labels: ['Q1', 'Q2', 'Q3', 'Q4'],
    datasets: [
      {
        label: 'Beispiel-Daten',
        data: [65, 59, 80, 81],
        backgroundColor: '#42A5F5',
      },
    ],
  };

  // Options: maintainAspectRatio=false zwingt den Canvas, wirklich die 100% seines Elterns anzunehmen
  basicOptions = {
    width: 10,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true },
    },
  };

  ngOnInit() {}
}
